import { StyleSheet } from 'aphrodite';

let styles = {
  site: {
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
    marginBottom: 5
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/accordion/Accordion.styles.js